import {is_array} from "./arrays";
import {getCurrentTime} from "./dates";

export const isEmpty = (value) => {
    return (typeof value === "undefined" || value === '' || value === null);
};

export const time_ago = (timeAgo, limitUntil = null, limitFrom = null, getExactTime = false) => {
    let time = getCurrentTime();
    let startDayTime = ((new Date()).setHours(0, 0, 0, 0) / 1000) - 1;
    const today = (timeAgo > startDayTime);
    let dayTitle = today ? 'امروز' : 'دیروز';

    let timeElapsed = time - timeAgo;
    let seconds = timeElapsed;

    let days = Math.floor(timeElapsed / 86400);

    // Seconds
    if (seconds < 60) {
        if (today) {
            return "لحظاتی پیش";
        }

        return dayTitle;
    } else {
        //Minutes
        let minutes = Math.floor(timeElapsed / 60);
        if (minutes < 60) {
            if (today) {
                return minutes + " دقیقه پیش";
            }

            return dayTitle;
        } else {
            //Hours
            let hours = Math.floor(timeElapsed / 3600);
            if (hours < 24) {
                if (today) {
                    return hours + " ساعت پیش";
                }

                return dayTitle;
            } else {
                //Days
                timeElapsed = startDayTime - timeAgo;
                let days = Math.floor(timeElapsed / 86400) + 1;
                if (days < 7) {
                    if (days === 1) {
                        return "دیروز";
                    } else {
                        return days + " روز پیش";
                    }
                } else {
                    //Weeks
                    let weeks = Math.floor(timeElapsed / 604800) + 1;
                    if (weeks <= 4.3) {
                        return weeks + " هفته پیش";
                    } else {
                        //Months
                        let months = Math.floor(timeElapsed / 2600640) + 1;
                        if (limitUntil === '6_month') {
                            if (months > 6) {
                                return "6 ماه پیش";
                            } else {
                                return months + " ماه پیش";
                            }
                        } else if (!isNaN(months) && months <= 12) {
                            return months + " ماه پیش";
                        } else {
                            //Years
                            let years = Math.floor(timeElapsed / 31207680) + 1;
                            return (years > 0 ? years : '') + " سال پیش";
                        }
                    }
                }
            }
        }

    }
};

export const str_replace = (search, replace, subject, countObj) => {
    let i = 0;
    let j = 0;
    let temp = '';
    let repl = '';
    let sl = 0;
    let fl = 0;
    let f = [].concat(search);
    let r = [].concat(replace);
    let s = subject;
    let ra = Object.prototype.toString.call(r) === '[object Array]';
    let sa = Object.prototype.toString.call(s) === '[object Array]';
    s = [].concat(s);
    let $global = (typeof window !== 'undefined' ? window : global);
    $global.$locutus = $global.$locutus || {};
    let $locutus = $global.$locutus;
    $locutus.php = $locutus.php || {};
    if (typeof (search) === 'object' && typeof (replace) === 'string') {
        temp = replace;
        replace = [];
        for (i = 0; i < search.length; i += 1) {
            replace[i] = temp
        }
        temp = '';
        r = [].concat(replace);
        ra = Object.prototype.toString.call(r) === '[object Array]'
    }
    if (typeof countObj !== 'undefined') {
        countObj.value = 0
    }
    for (i = 0, sl = s.length; i < sl; i++) {
        if (s[i] === '') {
            continue
        }
        for (j = 0, fl = f.length; j < fl; j++) {
            temp = s[i] + '';
            repl = ra ? (r[j] !== undefined ? r[j] : '') : r[0];
            s[i] = (temp).split(f[j]).join(repl);
            if (typeof countObj !== 'undefined') {
                countObj.value += ((temp.split(f[j])).length - 1)
            }
        }
    }
    return sa ? s : s[0]
};

export const randomString = (char = 6) => {
    let text = "";
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz123456789";

    for (var i = 0; i < char; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
};

export const scrollToRef = (ref, variance = 0, smooth = true) => {
    window.scrollTo({
        top: (ref.current.offsetTop - variance),
        left: 0,
        behavior: (smooth) ? 'smooth' : 'auto'
    })
};

export const scrollToOffsetTop = (offsetTop, variance = 0, smooth = true) => {
    window.scrollTo({
        top: (offsetTop - variance),
        left: 0,
        behavior: (smooth) ? 'smooth' : 'auto'
    })
};

export function scrollToTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

export function nl2br(str, is_xhtml) {
    if (typeof str === 'undefined' || str === null) {
        return '';
    }
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}

export function httpBuildQuery(object) {
    let query = '';

    Object.keys(object).forEach((key, index) => {
        const value = object[key];
        if (value && is_array(value) && value.length) {
            let and_index = index;

            for (let item of value) {
                if (!isEmpty(item)) {
                    query += ((and_index > 0) ? '&' : '') + key + '[]=' + item;
                    and_index += 1;
                }
            }
        } else if (value && !is_array(value) && !isEmpty(value)) {
            query += ((index > 0) ? '&' : '') + key + '=' + value;
        }
    });

    return query;
}

export function convertToFarsiChar(text) {
    const persianChars = [' ', 'ا', 'ب', 'پ', 'ت', 'ث', 'ج', 'چ', 'ح', 'خ', 'د', 'ذ', 'ر', 'ز', 'ژ', 'س', 'ش', 'ص', 'ض', 'ط', 'ي', 'ظ', 'ة', 'ع', 'غ', 'ف', 'ق', 'ک', 'گ', 'ل', 'م', 'ن', 'و', 'ه', 'آ', 'ء', '-‌', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
    const latinChars = [' ', 'h', 'f', 'm', 'j', 'e', '[', ']', 'p', 'o', 'n', 'b', 'v', 'c', 'C', 's', 'a', 'w', 'q', 'x', 'X', 'z', 'Z', 'u', 'y', 't', 'r', ';', '\'', 'g', 'l', 'k', ',', 'i', 'H', 'N', '-‌', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
    let index = 0;
    let farsiText = '';

    for (let i = 0; i < text.length; i++) {
        index = latinChars.indexOf(text[i]);
        if (index >= 0) {
            farsiText += persianChars[index];
        } else {
            farsiText += text[i];
        }
    }

    return farsiText;
}

export const getUrlParams = (url) => {
    let params = `${url}?`.split('?')[1];
    let query = {};

    if (!isEmpty(params)) {
        params = params.split('&');

        Object.keys(params).map(function (key) {
            const param = params[key].split('=');

            if (param[0].indexOf('[]') !== -1) {
                const itemKey = str_replace('[]', '', param[0]);
                const items = query[itemKey] ?? [];
                items.push(param[1]);

                query[itemKey] = items;
            } else {
                query[param[0]] = param[1];
            }
        });
    }

    return query;
};

export function getScrollbarWidth() {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);

    const inner = document.createElement('div');
    outer.appendChild(inner);

    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
}

export function handleLockBrowserScroll(lock = true) {
    const root = document.getElementsByTagName('html')[0];
    const investmentDrawer = document.querySelector('.js-investment-drawer');
    const investmentDrawerButton = document.querySelector('.js-investment-drawer-button');
    const fixedNavbar = document.querySelector('.fixed-navbar');
    const searchFilterFixed = document.querySelector('.search-filter.fixed-top');
    const fullscreenSwiperContainer = document.querySelector('.fullscreen-swiper-container');
    const bulletLoadingBox = document.querySelector('.bullet-loading-box');

    const paddingRights = [fixedNavbar, searchFilterFixed, fullscreenSwiperContainer, bulletLoadingBox];

    if (lock) {
        root.classList.add('html-modal-open');

        if (window.innerWidth > 991) {
            const scrollWith = getScrollbarWidth();
            document.body.style.paddingRight = scrollWith + 'px';

            if (!isEmpty(investmentDrawer)) {
                investmentDrawer.style.right = scrollWith + 24 + 'px';
            }

            if (!isEmpty(investmentDrawerButton)) {
                investmentDrawerButton.style.right = scrollWith + 24 + 'px';
            }

            for (let el of paddingRights) {
                if (!isEmpty(el)) {
                    el.style.paddingRight = scrollWith + 'px';
                }
            }
        }
    } else {
        root.classList.remove('html-modal-open');

        document.body.style.paddingRight = '0px';

        if (!isEmpty(investmentDrawer)) {
            investmentDrawer.style.right = 24 + 'px';
        }

        if (!isEmpty(investmentDrawerButton)) {
            investmentDrawerButton.style.right = 24 + 'px';
        }

        for (let el of paddingRights) {
            if (!isEmpty(el)) {
                el.style.paddingRight = '0px';
            }
        }
    }
}

/**
 * @param string {String}
 * @param length {Number}
 *
 * @return String
 */
export function truncateString(string, length = 50) {
    return !isEmpty(string) ? string.substring(0, length) + '...' : '';
}

/**
 * @param url {String}
 * @param parameter {String}
 *
 * @return String
 * */
export function removeURLParameter(url, parameter) {
    const urlParts = url.split('?');
    if (urlParts.length >= 2) {

        const prefix = encodeURIComponent(parameter) + '=';
        const pars = urlParts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (let i = pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        return urlParts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }

    return url;
}